(function () {
    angular.module('tmx-app').service('tmxUtility', ['cacheStore', 'APP_CONSTANTS', '$location', '$anchorScroll','TMX_FINANCE_CONSTANTS',

        function tmxUtility(cacheStore, APP_CONSTANTS, $location, $anchorScroll,TMX_FINANCE_CONSTANTS) {
            var utility = this;
            utility.groupBy = groupBy;
            utility.getAsynch = getAsynch;
            utility.findItems = findItems;
            utility.applyClassOnRows = applyClassOnRows;
            utility.resolveAttr = tmxResolveAttr;
            utility.exists = exists;
            utility.sliceText = sliceText;
            utility.copy = copy;
            utility.checkEndDate = checkEndDate;
            utility.setStartDate = setStartDate;
            utility.setEndDate = setEndDate;
            utility.filter = filter;
            utility.strToHashCode = strToHashCode;
            utility.addToMany = addToMany;
            utility.getWeekNumber = getWeekNumber;//get week of year of given date
            utility.generateGuid = generateGuid;
            utility.checkPermission = checkPermission;
            utility.checkTabPermission = checkTabPermission;
            utility.getConfigurationValue = getConfigurationValue;
            utility.formatDate = formatDate;
            utility.formatMonthYear = formatMonthYear;
            utility.TimeStampFormatting = TimeStampFormatting;
            utility.splitString = splitString;
            utility.getPropertyValue = getPropertyValue;
            utility.formatDateSpecific = formatDateSpecific;
            utility.sortByAttr = sortByAttr;
            utility.checkUserRole = checkUserRole;
            utility.orderArrayByProperty = orderArrayByProperty;
            utility.formatColumnName = formatColumnName;
            utility.getCurrentCulture = getCurrentCulture;
            utility.gotoAnchor = gotoAnchor;
            utility.getScreenWidthCode = getScreenWidthCode;
            utility.getScreenWidth = getScreenWidth;
            utility.hasDuplicates = hasDuplicates;
            utility.isFunction = isFunction;
            utility.formatDateForCompany=formatDateForCompany;
            utility.formatDateTimeForCompany=formatDateTimeForCompany;    
            utility.columnsMapping=columnsMapping;        
            utility.dataMapping=dataMapping;
            utility.SetStatusBackgroundColor=SetStatusBackgroundColor;
            utility.formatAmount = formatAmount;

            function orderArrayByProperty(arr, columns, order) {
                // sort array by multiple properties with different orders. 
                //orderArrayByProperty(arr,[Column1,Column2],[asc,desc]) is  Equivalent to SQL ORDER BY Column1 ASC, Column2 DESC
                if (arr == null || !angular.isDefined(arr))
                    return "";
                else {
                    return _.orderBy(arr, columns, order);
                }
            }

            function hasDuplicates(arr) {
                return _.uniq(arr).length !== arr.length;
            }

            function formatAmount(number){ // returns amount with commas  eg100,000
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            function formatDateForCompany(date) {
                var compnyDateFormat = cacheStore.get('CompanyDateFormat');
                if (compnyDateFormat)
                    return formatDateSpecific(date, compnyDateFormat)
                else
                    return formatDateSpecific(date, 'DD MMM YYYY')
            }

            function formatDateTimeForCompany(date) {
                if (angular.isDate(date)) {
                    date = date.toISOString();
                }
                var compnyDateFormat = cacheStore.get('CompanyDateFormat');
                if (compnyDateFormat)
                    return TimeStampFormatting(date, compnyDateFormat)
                else
                    return TimeStampFormatting(date, 'DD MMM YYYY')
            }

            function TimeStampFormatting(dateTime, format) {
                if (dateTime) {
                    var date = "";
                    if (!dateTime.includes('Z'))
                        date = new Date(dateTime + 'Z');
                    else
                        date = new Date(dateTime);

                    var formattedDate= moment(date).format(format);                    
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;                    
                    return formattedDate + " " + strTime;
                }
                else {
                    return "N/A";
                }
            }

            function formatDateSpecific(dateValue, format) {
                if (!exists(dateValue))
                    return "";
                else {
                    var date = new Date(dateValue);
                    return moment(date).format(format);
                }
            }


            function formatDate(dateValue) {
                if (dateValue) {
                    // var date = new Date(dateValue + "Z");
                    var date = new Date(dateValue);
                    var x = date.getMonth();
                    var month = "";
                    switch (x) {
                    case 0:
                        month = "Jan";
                        break;
                    case 1:
                        month = "Feb";
                        break;
                    case 2:
                        month = "Mar";
                        break;
                    case 3:
                        month = "April";
                        break;
                    case 4:
                        month = "May";
                        break;
                    case 5:
                        month = "June";
                        break;
                    case 6:
                        month = "July";
                        break;
                    case 7:
                        month = "Aug";
                        break;
                    case 8:
                        month = "Sept";
                        break;
                    case 9:
                        month = "Oct";
                        break;
                    case 10:
                        month = "Nov";
                        break;
                    case 11:
                        month = "Dec";
                        break;
                    }

                    return date.getDate() + "-" + month + "-" + date.getFullYear();
                }
                else {
                    return "";
                }

            }

            function formatMonthYear(dateValue) {
                if (dateValue) {
                    // var date = new Date(dateValue + "Z");
                    var date = new Date(dateValue);
                    var x = date.getMonth();
                    var month = "";
                    switch (x) {
                    case 0:
                        month = "Jan";
                        break;
                    case 1:
                        month = "Feb";
                        break;
                    case 2:
                        month = "Mar";
                        break;
                    case 3:
                        month = "April";
                        break;
                    case 4:
                        month = "May";
                        break;
                    case 5:
                        month = "June";
                        break;
                    case 6:
                        month = "July";
                        break;
                    case 7:
                        month = "Aug";
                        break;
                    case 8:
                        month = "Sept";
                        break;
                    case 9:
                        month = "Oct";
                        break;
                    case 10:
                        month = "Nov";
                        break;
                    case 11:
                        month = "Dec";
                        break;
                    }

                    return month + "-" + date.getFullYear();
                }
                else {
                    return "";
                }

            }


            function checkTabPermission(tabId, productId, privilege) {
                var EntityId = 0;
                var EntityObj = {};
                var obj = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).entities;
                var TabEntityMapping = cacheStore.get("TabEntityMapping");

                var TabEntityMappingItem = TabEntityMapping.filter(function (item) {
                    return item.ProductId == productId && item.TabId == tabId;
                });

                if (TabEntityMappingItem[0]) {
                    EntityId = TabEntityMappingItem[0].EntityId;
                }

                for (var property in obj) {
                    if (obj[property].id == EntityId) {
                        EntityObj = obj[property];
                        if (EntityObj) {
                            return EntityObj.privileges.hasOwnProperty(privilege);
                        }
                    }
                }
                return false;
            }

            function checkPermission(entity, previlegeName) {
                var alwaysAllowedMenus = ['ProfileLink', 'logout'];
                if (alwaysAllowedMenus.indexOf(entity) > -1) {
                    return true;
                }
                if (!previlegeName) { // If previlege name is not defined then check view previlege
                    previlegeName = 'View'
                }
                var checkEntity = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).entities[entity];
                if (checkEntity) {
                    return checkEntity.privileges.hasOwnProperty(previlegeName); //Check if key with the previlegeName is there in privileges object
                }
                return false;


            }


            function setStartDate(sdate) { //expected any input

                var startDate;
                if (sdate == null || !angular.isDefined(sdate)) {// Invalid Date check
                    startDate = new Date(sdate);//forming a date object from JSON string
                    return startDate;
                }
                if (!angular.isObject(sdate)) {//JSON check if its 19:00:00
                    sdate = sdate.split("T");
                    sdate = new Date(sdate[0]);

                }
                startDate = new Date(sdate);
                startDate.setHours(5, 0, 0);
                return startDate;
            }

            function setEndDate(edate) { //any input
                var endDate;
                if (edate == null || !angular.isDefined(edate)) {//Invalid end Date check
                    endDate = new Date(edate);//forming a date object from JSON string
                    return endDate;
                }
                if (angular.isObject(edate)) {
                    edate.setHours(5);
                    endDate = edate.toJSON();
                }
                else {
                    endDate = edate;
                }

                endDate = endDate.split("T");
                endDate = new Date(endDate[0]);

                endDate.setHours(28, 59, 59);
                return endDate;
            }
            function copy(source, attrs, destination) {
                if (!exists(source)) return;// return undefined if no source

                if (!exists(destination)) {// if no destination
                    if (!exists(attrs))// and no attrs
                        return angular.copy(source); // just return the copy of source
                    else
                        destination = {}; //but if attrs and no destination than make an empty destination
                }

                function replicate(attribute) {// copy/overwrite 'attribute' from source object to destination object
                    destination[attribute] = source[attribute];
                }

                if (!exists(attrs) || attrs.length == 0) {//We are certain to have a destination at this point, but if no attributes to copy are provided
                    attrs = Object.keys(source);// then use all attributes to copy
                }
                attrs.forEach(replicate);//iterate over all keys to copy
            }

            function sliceText(text, noOfCharacters) {
                if (text) {
                    if (!noOfCharacters) {
                        noOfCharacters = 10;
                    }
                    if (text.length > noOfCharacters) {
                        return text.slice(0, noOfCharacters) + "...";
                    }
                    else {
                        return text;
                    }
                }
                else {
                    return 'N/A';
                }

            }

            function exists(object, attr) {
                if (!angular.isDefined(object) || object == null || object == "Invalid Date") return false;
                if (!angular.isDefined(attr) || attr == null) return true;
                var obj = tmxResolveAttr(object, attr);
                return angular.isDefined(obj) && obj != null && object != "Invalid Date";
            }
          
            function formatColumnName(columnName) {
                // eslint-disable-next-line no-extra-boolean-cast
                return Boolean(APP_CONSTANTS.isOracleDB) ? columnName.toUpperCase() : columnName;
            }
            function checkEndDate(_StartDate, _EndDate) {

                var StartDate = new Date(_StartDate);//forming a date object from JSON string
                var StartDateString = StartDate.toDateString();//getting the date out of the whole date-time
                var StartDateNew = new Date(StartDateString);//converting the new string to date object

                var EndDate = new Date(_EndDate);
                var EndDateString = EndDate.toDateString();
                var EndDateNew = new Date(EndDateString);//converting the new string to date object


                if (_EndDate == undefined ||
                    _EndDate == null ||
                    StartDateNew > EndDateNew) {
                    //if start date is greater than end date -> make end date field in form invalid

                    return true;
                }
                else {
                    return false;
                }

            }

            function tmxResolveAttr(obj, attr) {
                if (attr == 0) return;
                var attrs = attr.split(".");
                var index = attr.indexOf(".");
                if (attrs.length == 0) return;
                if (attrs.length == 1) return obj[attrs[0]];
                if (!exists(obj[attrs[0]])) return undefined;
                return tmxResolveAttr(obj[attrs[0]], attr.substr(index + 1, attr.length - index));
            }

            function getPropertyValue(o, s) { // Get deep property value by string path. o: object , s: property path
                try {
                    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                    s = s.replace(/^\./, '');           // strip a leading dot
                    var a = s.split('.');
                    for (var i = 0, n = a.length; i < n; ++i) {
                        var k = a[i];
                        if (k in o) {
                            o = o[k];
                        }
                        else {
                            return;
                        }
                    }
                    return o;
                }
                catch (e) {
                    return null;
                }
            }

            function applyClassOnRows(kendoGrid, attrName, attrValue, className, remove) {
                var list = kendoGrid.dataItems();
                var items = findItems(attrName, attrValue, list);
                function applyClassOnRow(item) {
                    var row = kendoGrid.element.find("tr[data-uid=" + item.uid + "]")[0];
                    if (remove) {
                        var classes = className.split(" ");
                        classes.forEach(function (className) { row.className = row.className.replace(className, ""); });
                    }
                    else {
                        row.className += " " + className;
                    }
                }
                items.forEach(applyClassOnRow);
            }

            function findItems(attrName, attrValue, items) {//returns the items in the list with matching attribute value
                var result = [];
                for (var i = 0; i < items.length; i++) {
                    if (items[i][attrName] == attrValue) {
                        result.push(items[i]);
                    }
                }
                return result;
            }

            function filter(items, query) {
                var keys = Object.keys(query);
                var filtered = items;
                keys.forEach(function (key) {
                    filtered = findItems(key, query[key], filtered);
                });
                return filtered;
            }

            function _groups(array) {
                var obj = this;
                obj.total = 0;
                obj.totalValues = array.length;
                obj.names = [];
            }

            function generateGuid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }

            _groups.prototype.registerId = function (keyname, id) {// you can register your own Id to 
                var obj = this;
                if (!angular.isDefined(obj.idMap)) {
                    obj.idMap = {
                        keyToId: {},
                        idToKey: {}
                    };
                }
                if (angular.isDefined(obj.nameMap.labelToCol[keyname])) {//if keyname is the label given to group
                    keyname = obj.nameMap.labelToCol[keyname];//get the keyname from map
                }
                if (!angular.isDefined(obj[keyname]) && !angular.isDefined(obj.nameMap.colToLabel[keyname])) {//condition for invaid keyname
                    return false;
                }
                if (angular.isDefined(obj.idMap.keyToId[keyname]) || angular.isDefined(obj.idMap.idToKey[id])) {
                    //means either key is already registered to another id or this id is mapped to another keyname
                    //TO DO handle these cases
                }
                else {
                    obj.idMap.keyToId[keyname] = id;
                    obj.idMap.idToKey[id] = keyname;
                }
                return true;
            };

            _groups.prototype.getById = function (id) {
                var obj = this;
                var result;
                if (angular.isDefined(obj[id])) return obj[id];
                if (angular.isDefined(obj.idMap) && angular.isDefined(obj.idMap.idToKey[id])) {
                    var key = obj.idMap.idToKey[id];
                    result = obj[key] || obj[obj.nameMap.colToLabel[key]];
                    return result;
                }
                else if (angular.isDefined(obj.nameMap.colToLabel[id]) || angular.isDefined(obj.nameMap.labelToCol[id])) {
                    result = obj[id] || obj[obj.nameMap.colToLabel[id]];
                    return result;
                }
                return [];

            }

            //performs GROUP BY on an array
            function groupBy(array, onBasisOf, groupName, forceInvalidId) {
                var groups = new _groups(array);
                if (!angular.isDefined(groupName)) groupName = "group";
                var nameMap = {
                    labelToCol: {},
                    colToLabel: {},
                };
                var counter = 0;
                array.forEach(function (o) { //create map
                    var group = onBasisOf(o);
                    if (!exists(group)) return;//ignore the item if it does not belong to any group
                    var name = group;
                    if (!isvalidIdentifier(group) && !forceInvalidId) {//if the value is not valid identifier
                        if (!angular.isDefined(nameMap.colToLabel[group])) {//first see if it already is doesn't exists in map
                            nameMap.labelToCol[groupName + "_" + counter] = group;//now create a valid identifier and map it to that key
                            nameMap.colToLabel[group] = groupName + "_" + counter++;
                        }
                        group = nameMap.colToLabel[group];//now the identifier we created in above step will be used to access th group
                    }
                    if (!angular.isDefined(groups[group])) {
                        groups.total++;
                        groups.names.push(group);
                    }
                    groups[group] = groups[group] || [];
                    o.realName = name;
                    groups[group].push(o);
                });
                if (angular.isDefined(nameMap)) groups.nameMap = nameMap;


                return groups;
            }

            function sortByAttr(array, attrName) {
                if (exists(array) && array.length > 0) {
                    return array.sort((a, b) => a[attrName] - b[attrName]).slice();
                }
                return array;
            }

            function isvalidIdentifier(string) {
                return (typeof (string) === "string") && (angular.isDefined(string.match(identifierRegex)));
            }

            function getAsynch($q, calls) {
                var deferred = $q.defer();
                var counter = 0;
                var result = {};
                calls.forEach(
                    function (call) {
                        //If call is a promise
                        if (angular.isDefined(call.promise.then)) {
                            call.promise.then(
                                function (resultOfCall) {
                                    result[call.key] = resultOfCall;
                                    counter++;
                                    if (counter === calls.length) {
                                        deferred.resolve(result);
                                    }
                                }
                            );
                        }
                        else {//else if it is a regular valriable
                            result[call.key] = call.promise;
                            counter++;
                            if (counter === calls.length) {
                                deferred.resolve(result);
                            }
                        }
                    }
                );
                return deferred.promise;
            }


            function strToHashCode(str) {
                var hash = 0, i, chr, len;
                if (str.length === 0) return hash;
                for (i = 0, len = str.length; i < len; i++) {
                    chr = str.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                return hash;
            }


            function addToMany(array, from, to, suffix, seperator) {//adds something to an array (from and to inclusive), 
                var result = [];
                for (var i = from; i <= to; i++) {
                    if (exists(seperator) && exists(suffix)) {
                        result.push(array[i] + "_" + suffix);
                    }
                    else if (exists(suffix)) result.push(array[i] + suffix);
                    else result.push(array[i]);
                }
                return result;
            }

            function splitString(stringObj, index) {
                return [stringObj.substring(0, index), stringObj.substring(index)];
            }

            function getConfigurationValue(configCollection, configKey, shouldParse = false, productId = null) {
                var config = configCollection.find(function (item) {
                    if (!productId) {
                        return item.ConfigurationKey == configKey;
                    }
                    else {
                        return (item.ConfigurationKey == configKey && item.ProductId == productId)
                    }
                });
                return config ? (shouldParse ? JSON.parse(config.ConfigurationValue.toLowerCase()) : config.ConfigurationValue) : "";
            }

            function checkUserRole(roleToCheck) {
                var roleFound = false;
                var roles = JSON.parse(localStorage.getItem('LoggedInUserPrivileges')).roles;
                if (exists(roles)) {
                    Object.keys(roles).forEach(key => {
                        if (roles[key].name == roleToCheck) {
                            roleFound = true;
                            return;
                        }
                    });
                }
                return roleFound;
            }

            function getCurrentCultureCode() {
                return localStorage.getItem('culture');
            }

            function getCurrentCulture() {
                var cultureCode = getCurrentCultureCode();
                switch (cultureCode) {
                case 'en':
                    return 'English';
                case 'ar':
                    return 'Arabic';
                default:
                    return 'Default';
                }
            }

            function gotoAnchor(id) {
                $location.hash(id);
                $anchorScroll();
            }


            function getWeekNumber(date) {
                var d = new Date(+date);
                d.setHours(0, 0, 0);
                d.setDate(d.getDate() + 4 - (d.getDay() || 7));
                return Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
            }

            function getScreenWidth() {
                return screen.availWidth;
            }
            function getScreenWidthCode() {
                var width = getScreenWidth();
                if (width < 600) {
                    return 'xs';
                }
                else if (width < 960) {
                    return 'sm';
                }
                else if (width < 1280) {
                    return 'md';
                }
                else {
                    return 'lg'
                }

            }

            function isFunction(functionToCheck) {
                return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
            }
            // eslint-disable-next-line
            var identifierRegex = /^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc][$A-Z\_a-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc0-9\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19b0-\u19c0\u19c8\u19c9\u19d0-\u19d9\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2-\u1cf4\u1dc0-\u1de6\u1dfc-\u1dff\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8e0-\ua8f1\ua900-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f]*$/;

            function columnsMapping(gridColumns){
                var columns= [];
                gridColumns.map(function(col){
                    if(exists(col.title) && col.title!=""){
                        var obj= {
                            value: col.title ? col.title : col.field,
                            autoWidth:true,
                            background: "#7a7a7a",
                            color: "#fff",
                            field:col.field
                        };
                        columns.push(obj);
                    }
                });
                return columns;                
            }

            function dataMapping(data,columns){   
                var rows = [{cells:columns, type: "header"}];             
                for (var i = 0; i < data.length; i++){
                    var rowCells = [];
                    for(var j=0;j < columns.length;j++){                     
                        var cellValue = data[i][columns[j].field];
                        rowCells.push({value: cellValue});                        
                    }
                    rows.push({cells: rowCells, type: "data"});
                }
                return rows;
            }

            function SetStatusBackgroundColor(dataValue) {  
                                
                var value=TMX_FINANCE_CONSTANTS.STATUS_BACKGROUND_COLOR[dataValue.toLowerCase()];                
                if(!value){
                    
                    return TMX_FINANCE_CONSTANTS.DEFAULT_STATUS_BACKGROUND_COLOR;
                }
                else{
                    return value;
                }                                          
            }            
        }]);
})();